module.exports = __webpack_public_path__ + "img/icon02.b96b552c.png";